import * as models from 'src/models';
import * as types from 'src/localization/types';

export const localized: types.Localization<Record<models.loginType.types.LoginType, string>> = (env) => ({
  password: env.localizer('models.loginType.password'),
  certificate: env.localizer('models.loginType.certificate')
});
